import React, { useState } from "react";
import styles from "./WebsiteApps.module.css";
import ProductTree from "./ProductTree";
// import { allProducts } from "../../utils/all_Product_DummyData";

const WebsiteApps = () => {
  const [loaded, setIsLoaded] = useState(false);
  const [products, setProducts] = useState([]);
  const [isSomethingChanged, setIsSomethingChanged] = useState(false);

  React.useEffect(() => {
    async function fetchAllProd() {
      setIsLoaded(false);
      try {
        fetch(`${process.env.REACT_APP_SERVER_URL}/get_all_products`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
          method: "GET",
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else {
              console.log("some error");
              setIsLoaded(true);
              return response.json();
            }
          })
          .then((data) => {
            setProducts(data.data);
            setIsLoaded(true);
          })
          .catch((error) => console.log(error));
      } catch (error) {
        console.log(error);
        setIsLoaded(true);
      }
    }
    fetchAllProd();
  }, [isSomethingChanged]);

  const [searchTerm, setSearchTerm] = useState("");

  const refetchAllProducts = () => {
    setIsSomethingChanged(!isSomethingChanged);
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const filteredData = products?.filter((item) =>
    item.app_name.toLowerCase().includes(searchTerm)
  );

  if (!loaded) return <p className="text-center py-10">Loading...</p>;

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>Website Apps</h1>

      {/* Search Filter */}
      <div className={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search apps..."
          className={styles.searchInput}
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>

      {/* {console.log("")} */}
      <ProductTree
        allProducts={filteredData}
        refetchAllProducts={refetchAllProducts}
      />
    </div>
  );
};

export default WebsiteApps;
